module.exports = __webpack_public_path__ + "static/media/ERP.aeee1066.svg";